import { SocketConnectionWorker } from '../../../components/SocketConnection';
import { EVENT_SELECT_VEHICLES } from '../../../components/SocketConnection/constants';
import { getUserId } from '../../../Services/UserService';

export const setSelectedVehiclesToSocketServerEffect =
  () =>
  ({ onSet }): void => {
    onSet((newValue: number[]) => {
      const data = {
        event: EVENT_SELECT_VEHICLES,
        payload: newValue,
        userId: getUserId(),
      };
      SocketConnectionWorker.postMessage(data);
    });
  };

export default setSelectedVehiclesToSocketServerEffect;
